<template>
    <div class="uav-container">
        <!-- PC端显示 -->
        <div class="card" v-if="pageWidth > 1000">
            <!-- 产品简介部分 -->
            <div class="situation" >
                <div class="radio">
                    <div class="text animate__animated animate__fadeInLeft">
                        <h2 class="title">01 <span>{{ title }}</span></h2>
                        <p class="introduction">
                            {{ introduce }}
                        </p>
                    </div>
                    <div class="image animate__animated animate__fadeInRight">
                        <img src="@/assets/solution/pingtai/pf1.png" alt="低空频谱监测平台">
                        <p>低空频谱监测平台</p>
                    </div>
                </div>

                <!-- 产品特色部分 -->
                <div class="features-container">
                    <div class="text technicalPoints">
                        <h3 class="title"><span>产品特色</span></h3>
                        <div v-for="(point, index) in productFeatures" :key="index">
                            <h4>{{ point.title }}</h4>
                            <p>{{ point.description }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 功能说明部分 -->
            <div class="situation">
                <div class="text functionDesc" style="width: 100%">
                    <h3 class="title"><span>功能说明</span></h3>
                    <table class="function-table">
                        <tr>
                            <th>模块</th>
                            <th>功能</th>
                            <th>说明</th>
                        </tr>
                        <tr>
                            <td>频谱驾驶舱</td>
                            <td>GIS地图</td>
                            <td>基于网络的WebGIS电子地图管理与服务功能，使地图数据和频谱相关信息能在WEB环境下进行发布和浏览。所有前端固定基站设备、航道通信质量、导航信号质量、无人机状态等信息在GIS地图上进行标注，以GIS地图的方式进行可视化呈现，满足用户对频谱资源的宏观管理、分析的需要。</td>
                        </tr>
                        <tr>
                            <td rowspan="2"></td>
                            <td>频谱态势展示</td>
                            <td>从立体空间、时间、频率、场强能量等维度进行频谱数据采集与分析，呈现更加全面、完整的电磁频谱态势信息。</td>
                        </tr>
                        <tr>
                            <td>频谱语义展示</td>
                            <td>根据频谱信息，提取出语义信息并展示在软件界面上，突出AI相关能力展示的方式包括文字输出、图像圈注等。从而降低用频人员的使用门槛。</td>
                        </tr>
                        <tr>
                            <td rowspan="2">频谱数据管理</td>
                            <td>数据管理</td>
                            <td>平台存储历史测绘/测向任务采集的数据，支持查询、导出、回放等功能。</td>
                        </tr>
                        <tr>
                            <td>信息搜索</td>
                            <td>支持全属性(时间、频段、任务等)查询频谱信息，定期生成报表，发送到指定邮箱。</td>
                        </tr>
                        <tr>
                            <td>频谱数据离线分析</td>
                            <td>平台支持导入并分析频谱数据</td>
                            <td>输出分析报告、频谱态势、频谱语义。</td>
                        </tr>
                        <tr>
                            <td>设备管理</td>
                            <td colspan="2">对无人机、测绘仪、测向仪、机座等设备进行管理</td>
                        </tr>
                        <tr>
                            <td>任务管理</td>
                            <td colspan="2">在执行测绘或测向任务之前，可以利用平台的任务管理功能对本次作业任务进行规划，主要包括测绘仪/测向仪的参数设置、无人机飞行区域规划、任务参与人员、时间等信息的记录等。</td>
                        </tr>
                        <tr>
                            <td>平台对接</td>
                            <td colspan="2">具备通用API接口，可以接入其它平台频谱数据；支持与大情报系统、指挥中心有关指挥系统对接，实现情报指挥一体化。</td>
                        </tr>
                    </table>
                </div>
            </div>

            <!-- 应用案例部分 -->
            <div class="situation">
                <div class="text" style="width: 100%" ref="text">
                    <h3 class="title"><span>应用案例</span></h3>
                    <div class="scenario">
                        <div ref="text">
                            <div v-for="(scene, index) in applicationScenes" :key="index">
                                <h4>{{ scene.title }}</h4>
                                <p>{{ scene.description }}</p>
                            </div>
                        </div>

                        <div class="image_box" ref="img">
                            <img v-for="(image, index) in sceneImages"
                                 :key="index"
                                 :src="image"
                                 :alt="`场景图片${index + 1}`">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 移动端显示 -->
        <div class="card" v-else>
            <div class="situation">
                <div class="text animate__animated animate__fadeInLeft">
                    <h2 class="title">01 <span>{{ title }}</span></h2>
                    <p class="introduction">
                        {{introduce}}
                    </p>
                    <div class="image animate__animated animate__fadeInRight">
                        <img src="@/assets/solution/pingtai/pf1.png" alt="抗干扰无人机">
                        <p>{{ title }}</p>
                    </div>

                    <!-- 产品特色部分 -->
                    <div class="technicalPoints">
                        <h3 class="title"><span>产品特色</span></h3>
                        <div v-for="(point, index) in productFeatures" :key="index">
                            <h4>{{ point.title }}</h4>
                            <p>{{ point.description }}</p>
                        </div>
                    </div>

                    <!-- 功能说明部分 -->
                    <div class="functionDesc">
                        <h3 class="title"><span>功能说明</span></h3>
                        <table class="function-table">
                            <tr>
                                <th>模块</th>
                                <th>功能</th>
                                <th>说明</th>
                            </tr>
                            <tr>
                                <td>频谱驾驶舱</td>
                                <td>GIS地图</td>
                                <td>基于网络的WebGIS电子地图管理与服务功能，使地图数据和频谱相关信息能在WEB环境下进行发布和浏览。所有前端固定基站设备、航道通信质量、导航信号质量、无人机状态等信息在GIS地图上进行标注，以GIS地图的方式进行可视化呈现，满足用户对频谱资源的宏观管理、分析的需要。</td>
                            </tr>
                            <tr>
                                <td rowspan="2"></td>
                                <td>频谱态势展示</td>
                                <td>从立体空间、时间、频率、场强能量等维度进行频谱数据采集与分析，呈现更加全面、完整的电磁频谱态势信息。</td>
                            </tr>
                            <tr>
                                <td>频谱语义展示</td>
                                <td>根据频谱信息，提取出语义信息并展示在软件界面上，突出AI相关能力展示的方式包括文字输出、图像圈注等。从而降低用频人员的使用门槛。</td>
                            </tr>
                            <tr>
                                <td rowspan="2">频谱数据管理</td>
                                <td>数据管理</td>
                                <td>平台存储历史测绘/测向任务采集的数据，支持查询、导出、回放等功能。</td>
                            </tr>
                            <tr>
                                <td>信息搜索</td>
                                <td>支持全属性(时间、频段、任务等)查询频谱信息，定期生成报表，发送到指定邮箱。</td>
                            </tr>
                            <tr>
                                <td>频谱数据离线分析</td>
                                <td>平台支持导入并分析频谱数据</td>
                                <td>输出分析报告、频谱态势、频谱语义。</td>
                            </tr>
                            <tr>
                                <td>设备管理</td>
                                <td colspan="2">对无人机、测绘仪、测向仪、机座等设备进行管理</td>
                            </tr>
                            <tr>
                                <td>任务管理</td>
                                <td colspan="2">在执行测绘或测向任务之前，可以利用平台的任务管理功能对本次作业任务进行规划，主要包括测绘仪/测向仪的参数设置、无人机飞行区域规划、任务参与人员、时间等信息的记录等。</td>
                            </tr>
                            <tr>
                                <td>平台对接</td>
                                <td colspan="2">具备通用API接口，可以接入其它平台频谱数据；支持与大情报系统、指挥中心有关指挥系统对接，实现情报指挥一体化。</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <!-- 应用案例部分 -->
            <div class="compose">
                <div class="text" ref="text">
                    <h3 class="title"><span>应用案例</span></h3>
                    <div v-for="(scene, index) in applicationScenes" :key="index">
                        <h4>{{ scene.title }}</h4>
                        <p>{{ scene.description }}</p>
                        <div class="img" v-if="sceneImages[index]">
                            <img :src="sceneImages[index]" :alt="scene.title">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UavComponent',

    data() {
        return {
            pageWidth: window.innerWidth,
            title: '低空频谱监测平台',
            introduce: '低空频谱监测平台致力于对无线电频谱进行全面、精准的分析与呈现。通过导入频谱数据，集成先进的算法对频谱数据进行推演、预测、补全与融合，再结合频谱热力地图、频谱瀑布图、知识图谱等多种语义化的可视化技术，直观地呈现出空间的三维频谱态势。平台提供频谱数据库、频谱态势、分析结果、云端算法等多种云端调用服务；已适配多种频谱接收机、地面/天空频谱测绘仪、地面/天空频谱测向仪等设备，支持网络化、广域覆盖的低空频谱资源管理，建设完善且强大的频谱监测生态。',
            // 产品特色数据
            productFeatures: [
                {
                    title: '立体态势',
                    description: '利用无人机采集不同高度层的频谱信息，并传输至频谱监测平台，绘制出不同高度层的频谱态势图。'
                },
                {
                    title: '灵活算法',
                    description: '算法以插槽的方式嵌入到平台，和平台保持低耦合性，可以根据不同的应用案例灵活更换算法。'
                },
                {
                    title: '丰富接口',
                    description: '平台提供丰富的接口能力，包括频谱数据离线分析、频谱数据库调用、频谱算法调用等能力。'
                },
                {
                    title: '强大生态',
                    description: '平台具备功能完善且强大的监测生态，能够支持网络化、广域覆盖的低空监测资源管理。'
                }
            ],
            // 应用案例数据
            applicationScenes: [
                {
                    title: '案例一：太仓某区域频谱测绘',
                    description: '使用无人机对太仓某区域地面以及100米高度层的频谱数据采集，得到频谱强度分布态势、基站信号覆盖态势、导航干扰态势、控制链路态势、业务链路态势以及各个频段的频谱占用度信息。'
                },
                {
                    title: '案例二：江宁无人机示范区低空信号频谱测试',
                    description: '通过无人机挂载无线探针，在江宁无人机示范区开展无线专网低空信号频谱测试，分析无线专网频谱分布及其信号质量，与三维信号模型进行对比分析，给出无线专网的性能指标以及公网承载低空无人机业务的性能指标。实现无线频谱信号可观可测，提升无线专网运营服务水平，提高对无人机的无线通信保障能力。'
                },
                {
                    title: '案例三：低空安全管控平台',
                    description: '低空安全管控平台由低空安全管控软件平台、反无人机监测系统、非法辐射源搜寻定位系统和基站信号三维覆盖测量系统构成。利用区块链技术去中心化、不可纂改和可追溯等特性致力于解决空域安全、频谱安全、网络安全、数据安全等问题，赋能无人机生产商、移动网络运营商、数据服务节点和监管机构，实现了低空频谱资源有效管理、监管和保障，维护了低空秩序和安全。'
                },
                {
                    title: '案例四：电磁信号离线分析平台',
                    description: '电磁离线分析平台，支持IQ文件和频谱文件的离线分析，集通信信号分析和雷达信号分析于一体，支持数字调制信号时域频域及解调分析、雷达信号脉内特征和脉间特征分析，适用于离线信号分析及信号分析教学场景；内置试验和培训管理模块，更好的贴合教学、试验、训练场景。'
                },
                {
                    title: '案例五：频谱物联网云平台',
                    description: '采用云边端架构的频谱监测系统，地面常态化部署或由无人机搭载的频谱感知模块可将接收到的频谱数据实时回传至云平台进行分析，绘制频谱态势地图。'
                },
            ],
            // 应用案例图片
            sceneImages: [
                require('@/assets/solution/pingtai/anli1.png'),
                require('@/assets/solution/pingtai/anli2.png'),
                require('@/assets/solution/pingtai/anli3.png'),
                require('@/assets/solution/pingtai/anli4.png'),
                require('@/assets/solution/pingtai/anli5.png'),
            ]
        }
    },

    mounted() {
        this.initializeEventListeners();
        this.setupIntersectionObservers();
    },

    beforeDestroy() {
        this.removeEventListeners();
    },

    methods: {
        // 初始化事件监听器
        initializeEventListeners() {
            window.addEventListener('resize', this.handleResize);
        },

        // 移除事件监听器
        removeEventListeners() {
            window.removeEventListener('resize', this.handleResize);
        },

        // 处理窗口大小变化
        handleResize() {
            this.pageWidth = window.innerWidth;
        },

        // 设置交叉观察器
        setupIntersectionObservers() {
            this.$nextTick(() => {
                this.setupElementObserver(this.$refs.text, 'animate__fadeInLeft');
                this.setupElementObserver(this.$refs.img, 'animate__fadeInRight');
            });
        },

        // 创建元素观察器
        setupElementObserver(element, animationClass) {
            if (!element) return;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        element.classList.add('animate__animated', animationClass);
                        observer.disconnect();
                    }
                });
            });

            observer.observe(element);
        }
    }
}
</script>

<style scoped lang="less">
@import '../../../styles/spectrum/radioMonitoring';

// 添加新的样式
.uav-container {
    .introduction {
        text-indent: 2em;
    }

    .mobile-view {
        // 移动端特定样式
    }
}

.mobile-view {
    .compose {
        .text {
            .img {
                margin: 15px 0;
                text-align: center;

                img {
                    max-width: 100%;
                    height: auto;
                }

                p {
                    margin-top: 10px;
                    text-align: center;
                }
            }
        }
    }

    .technicalPoints {
        margin: 20px 0;
    }

    .introduction {
        text-indent: 2em;
        margin: 15px 0;
    }
}

.features-container {
    display: flex;
    flex-direction: column;
    gap: 30px; // 控制产品特色和系统参数之间的间距
    margin-top: 100px;
}

.functionDesc {
    margin-top: 40px;

    .function-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 20px;
        background-color: #fff;  // 添加白色背景

        th, td {
            border: 1px solid #ddd;
            padding: 12px 15px;
            text-align: left;
            vertical-align: top;
            line-height: 1.6;
        }

        th {
            background-color: #f5f5f5;
            font-weight: bold;
            color: #333;
        }

        td {
            color: #666;
        }

        // 第一列宽度
        th:first-child,
        td:first-child {
            width: 15%;
        }

        // 第二列宽度
        th:nth-child(2),
        td:nth-child(2) {
            width: 20%;
        }

        // 第三列宽度
        th:last-child,
        td:last-child {
            width: 65%;
        }
    }
}

// 移动端适配
@media screen and (max-width: 1000px) {
    .functionDesc {
        margin: 30px 0;
        overflow-x: auto; // 添加横向滚动

        .function-table {
            min-width: 600px; // 确保表格最小宽度

            th, td {
                padding: 8px 10px; // 减小内边距
                font-size: 13px; // 稍微减小字体大小
            }
        }
    }

    .mobile-view {
        .compose {
            // ... 其他移动端样式保持不变
        }
    }
}

.scenario {
    display: flex;
    gap: 40px;
    margin-top: 30px;

    .image_box {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        width: 45%;

        img {
            width: 100%;
            height: auto;
            border-radius: 4px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }
    }
}
</style>
